const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const WAITING_FOR_A_DOABLE = 30 * 1000;
const BACKED_OFF = 5 * MINUTE;

// Matches what TodoList shows the client as something to do
const isToDo = (doable) => doable.status === "available" && doable.doable_type !== "enquiry";

// webapp-alpha creates a probate client's doables after the case reaches the
// dashboard, so the dashboard checks for them while there's nothing to do.
// "instructed" is the only status webapp-alpha counts as active.
const isWaitingForADoable = (cse) =>
  cse.case_type === "probate" && cse.status === "instructed" && !cse.doables.some(isToDo);

const waitForADoable = (onScreenFor, failed) =>
  failed || onScreenFor >= BACKED_OFF ? BACKED_OFF : WAITING_FOR_A_DOABLE;

// How often the dashboard reloads on its own, given the last response and how
// long the dashboard has been on screen since it opened or the tab became visible
export const dashboardRefetchInterval = (data, { onScreenFor = 0, failed = false } = {}) => {
  switch (data?.session?.subject_type) {
    case "estate_agent":
      return HOUR;
    case "client":
      return data.cases.some(isWaitingForADoable) ? waitForADoable(onScreenFor, failed) : false;
    default:
      return false;
  }
};
